import { Component } from '@angular/core';

@Component({
  selector: 'app-vendors-importer',
  templateUrl: './vendors-importer.component.html',
  styleUrls: ['./vendors-importer.component.scss']
})
export class VendorsImporterComponent {

}
